import React, {useEffect, useState} from 'react';
import {shallowEqual, useDispatch, useSelector} from "react-redux";
import {useHistory} from "react-router-dom";
import {Form} from "react-final-form";
import {EnigooTextField} from "../../../../MyComponent/EnigooTextField";
import {EnigooCustomField} from "../../../../MyComponent/EnigooCustomField";
import GroupsSelectField from "../../../../MyComponent/Api/Admin/GroupsSelectField";
import {EnigooSelect} from "../../../../MyComponent/EnigooSelect";
import {MailTemplateSelectField} from "../../../../MyComponent/Api/Admin/MailTemplateSelectField";
import {EnigooDateTimeFieldv2} from "../../../../MyComponent/EnigooDateTimeFieldv2";
import ActionDaysSelect from "../Form/ActionDaysSelect";
import EnigooButton from "../../../../MyComponent/EnigooButton";
import {FiChevronDown, FiChevronRight, FiChevronUp, FiFilter, FiX} from "react-icons/fi";
import {useTranslation} from "react-i18next";
import {
    FILTER_BASICS,
    FILTER_CUSTOM_FIELDS, FILTER_DAYS,
    FILTER_ENTRANCES,
    FILTER_PRINT_MAIL, FILTER_REGISTRATION_WAY
} from "../../../../reducers/filterUser";
import UserFilterSetModal from "./UserFilterSetModal";
import WebChannelSelectField from "../../../../MyComponent/Api/Admin/WebChannelSelectField";
import {FiArrowDown, FiArrowUp, FiChevronsDown, FiChevronsUp} from "react-icons/all";
import VerifyRights from "../../../VerifyRights";

// defined at module level: a component declared inside UserFilterForm gets a new type on every render,
// which remounts the whole filter subtree and refetches every select field (groups, templates, ...)
const Filter = ({children, title, type}) => {
    const dispatch = useDispatch();
    const filterVisible = useSelector(state => state.reducerAdmin.filterUser.filterVisible);

    let [visible, setVisible] = useState(true);

    useEffect(() => {
        setVisible(filterVisible && filterVisible.includes(type));
    }, [filterVisible])

    return (
        <div className={"border border-grey-200 p-1 rounded shadow-md"}>
            <div className="flex flex-row items-center w-full">
                <span className="pl-3 text-grey-600 font-semibold mb-2 mt-2 cursor-pointer w-full text-xs select-none"
                      onClick={() => {
                          dispatch({
                              type: 'SET_FILTER_VISIBLE',
                              filter: type,
                          })
                          setVisible(!visible);
                      }}>{title}</span>
                <div className={"ml-auto flex flex-row space-x-2 select-none"}>
                        <span className={"cursor-pointer self-center text-grey-600"} onClick={() => {
                            dispatch({
                                type: 'SET_FILTER_VISIBLE',
                                filter: type,
                            })
                            setVisible(!visible);
                        }}>{visible ? <FiChevronsUp size={25}/> : <FiChevronsDown size={25}/>} </span>
                    <span className={"cursor-pointer select-none"} onClick={() => {
                        dispatch({
                            type: 'DELETE_SHOWN_FILTER',
                            filter: type
                        })
                    }}><FiX className={"text-red-700"} size={25}/></span></div>
            </div>
            <div className={`${visible ? "block" : "hidden"}`}>
                {children}
            </div>
        </div>
    )
}

const UserFilterForm = ({filter, filtering}) => {

    const {t} = useTranslation()

    let [filterOptionsModal, setFilterOptionsModal] = useState(false);

    let filterDirty = null;
    let filterSubmit = null;
    const history = useHistory();
    const dispatch = useDispatch();
    const {actualAction} = useSelector(
        state => ({customField: state.reducerAdmin.customField, actualAction: state.reducerAdmin.actualAction}),
        shallowEqual
    )

    const {filterUser} = useSelector(
        state => ({
            filterUser: state.reducerAdmin.filterUser
        }),
        shallowEqual
    )

    useEffect(() => {

    }, [actualAction])

    const {openFilter, filtered, filterData, shownFilters, filterVisible} = filterUser;

    const onKeyDownFilter = (event) => {
        if (event.key === 'Enter') {
            event.preventDefault();
            filterSubmit();
        }
    }

    const onFilter = (values) => {
        if (filterDirty) {
            filter(values);
        }
    }

    const renderBasicsFields = () => {
        if (filterUser.shownFilters.includes(FILTER_BASICS)) {
            return (
                <Filter title={t("basics.basicsFields")} type={FILTER_BASICS}>
                    <div
                        className={`grid grid-cols-2 lg:grid-cols-6 gap-2 w-full px-2`}>
                        <EnigooTextField label={t("accreditation.numberOfAcc") + ":"} type={"number"}
                                         name={"id"}
                                         placeHolder={t("accreditation.numberOfAcc")}
                                         onKeyDown={onKeyDownFilter}/>
                        <EnigooTextField name={"firstname"} label={t("basics.firstname") + ":"}
                                         placeHolder={t("basics.firstname")}
                                         onKeyDown={onKeyDownFilter}/>
                        <EnigooTextField name={"lastname"} label={t("basics.lastname") + ":"}
                                         placeHolder={t("basics.lastname")}
                                         onKeyDown={onKeyDownFilter}/>
                        <EnigooTextField name={"email"} label={t("basics.email") + ":"}
                                         placeHolder={t("basics.email")} onKeyDown={onKeyDownFilter}/>
                        <GroupsSelectField placeHolder={t("placeHolder.selectMulti")}
                                           name={"groupsId"} label={t("groups.single") + ":"}
                                           isMulti={true}
                                           filter={true} onKeyDown={onKeyDownFilter}/>
                    </div>
                </Filter>
            )
        }
        return null;
    }

    const renderCustomFields = () => {
        const customFields = actualAction.customField;

        if (filterUser.shownFilters.includes(FILTER_CUSTOM_FIELDS)) {
            if (customFields) {
                return (
                    <Filter title={t("userFields.plural")} type={FILTER_CUSTOM_FIELDS}>
                        <div
                            className={`grid grid-cols-2 lg:grid-cols-6 gap-2 w-full px-2`}>
                            {customFields.map((item, index) => (
                                <EnigooCustomField filter={true} customField={item}
                                                   key={index.toString()} onKeyDown={onKeyDownFilter}/>
                            ))}
                        </div>
                    </Filter>)
            }

        }
        return null;
    }

    const renderPrintEmail = (values, form) => {
        if (shownFilters.includes(FILTER_PRINT_MAIL)) {
            return (
                <Filter title={t("basics.printMailFields")} type={FILTER_PRINT_MAIL}>
                    <div className={"flex flex-col w-full px-2"}>
                        <div className={"grid grid-cols-2 lg:grid-cols-6 gap-2"}>
                            <EnigooSelect placeHolder={t("placeHolder.select")}
                                          label={t("basics.printed") + ":"} name={"printed"}
                                          onValueChange={(e) => {
                                              if (!e?.value || e.value === -1) {
                                                  form.change("printedFrom", undefined)
                                                  form.change("printedTo", undefined)
                                              }
                                          }}
                                          items={[{value: 1, label: t("basics.yes")}, {
                                              value: -1,
                                              label: t("basics.no")
                                          }]}
                                          defaultValue={["value", "label"]} isClearable={true}
                                          onKeyDown={onKeyDownFilter}/>
                            {(values?.printed && values?.printed !== -1) &&
                                <EnigooDateTimeFieldv2 label={t("accreditation.printedFrom") + ":"}
                                                       name={"printedFrom"}/>}
                            {(values?.printed && values?.printed !== -1) &&
                                <EnigooDateTimeFieldv2 label={t("accreditation.printedTo") + ":"} name={"printedTo"}/>}
                            <MailTemplateSelectField placeHolder={t("placeHolder.selectMulti")}
                                                     name={"wasSend"} label={t("email.sended") + ":"}
                                                     isMulti={true} addNoMail={true}
                                                     onValueChange={(e) => {
                                                         if (!e?.value || e.value.includes(-1)) {
                                                             form.change("mailSendFrom", undefined)
                                                             form.change("mailSendTo", undefined)
                                                         }
                                                     }}
                                                     toolTip={t("email.sendedToolTip")}
                                                     onKeyDown={onKeyDownFilter}/>
                            {(values?.wasSend && !values?.wasSend.includes(-1)) &&
                                <EnigooDateTimeFieldv2 label={t("accreditation.mailSendFrom") + ":"}
                                                       name={"mailSendFrom"}/>}
                            {(values?.wasSend && !values?.wasSend.includes(-1)) &&
                                <EnigooDateTimeFieldv2 label={t("accreditation.mailSendTo") + ":"}
                                                       name={"mailSendTo"}/>}
                        </div>
                    </div>
                </Filter>
            )
        }
        return null;
    }

    const renderEntrance = (values) => {
        if (shownFilters.includes(FILTER_ENTRANCES)) {
            return (
                <Filter title={t("deviceReports.entrances")} type={FILTER_ENTRANCES}>
                    <div className={`grid grid-cols-2 gap-2 w-full px-2`}>
                        <EnigooSelect placeHolder={t("placeHolder.select")}
                                      label={t("entrance.plural") + ":"}
                                      defaultValue={["value", "label"]}
                                      toolTip={t("entrance.entranceFilterToolTip")}
                                      name={"entrance"}
                                      items={[{value: 1, label: t("entrance.enter")}, {
                                          value: 2,
                                          label: t("entrance.enterDay")
                                      }, {value: 3, label: t("entrance.notEnter")}, {
                                          value: 4,
                                          label: t("entrance.notEnterDay")
                                      }]} onKeyDown={onKeyDownFilter}/>
                        {values?.entrance && (values?.entrance === 2 || values?.entrance === 4) &&
                            <EnigooDateTimeFieldv2 name={"entranceDate"}
                                                   label={t("entrance.date") + ":"}
                                                   showTimeSelect={false}
                                                   onKeyDown={onKeyDownFilter}/>}
                    </div>
                </Filter>
            )
        }
        return null;
    }

    const renderRegistration = (values) => {
        if (shownFilters.includes(FILTER_REGISTRATION_WAY)) {
            return (
                <Filter title={t("basics.registration")} type={FILTER_REGISTRATION_WAY}>
                    <div className={`grid grid-cols-2 gap-2 px-2`}>
                        <EnigooDateTimeFieldv2 label={t("accreditation.registerFrom") + ":"} name={"registerFrom"}
                                               onKeyDown={onKeyDownFilter}/>
                        <EnigooDateTimeFieldv2 label={t("accreditation.registerTo") + ":"} name={"registerTo"}
                                               onKeyDown={onKeyDownFilter}/>
                    </div>
                    <div className={"grid grid-cols-3 gap-2 px-2"}>
                        <EnigooSelect label={t("accreditation.registrationWay") + ":"} name={"registrationWay"} items={[
                            {id: 1, name: t("accreditation.registrationFromAdmin")},
                            {id: 2, name: t("accreditation.registrationFromWebChannel")}
                        ]}/>
                        {(values?.registrationWay && values?.registrationWay === 2) &&
                            <>
                                <EnigooTextField placeHolder={t("placeHolder.text")} name={"externalCode"}
                                                 label={t("externalCode.single") + ": "}
                                                 toolTip={t("externalCode.filterToolTip")}
                                                 onKeyDown={onKeyDownFilter}
                                />
                                <WebChannelSelectField filter={true} onKeyDown={onKeyDownFilter} name={'webChannel'}
                                                       label={t("webChannels.plural") + ":"} isMulti={true}/>
                            </>
                        }

                    </div>
                    <div className={`flex flex-row space-x-2 w-full px-2`}>


                    </div>
                </Filter>
            )
        }
        return null;
    }

    const renderDays = () => {
        if (shownFilters.includes(FILTER_DAYS)) {
            return <Filter title={t("action.days")} type={FILTER_DAYS}>
                <div className={"p-2"}>
                    <ActionDaysSelect actionId={actualAction.actualAction} type={"filter"}
                                      toolTip={t("action.daysFilterToolTip")}
                                      onKeyDown={onKeyDownFilter}/>
                </div>
            </Filter>

        }
        return null;
    }

    const _renderBody = ()=> {


        return <div className={"flex flex-col"}>
            <Form onSubmit={onFilter} initialValues={filterData}
                  render={({handleSubmit, values, dirty, form}) => {
                      filterDirty = dirty;
                      filterSubmit = handleSubmit;
                      return (
                          <>
                              <div className="flex items-center w-full">
                                  <span className="pl-3 text-grey-600 font-semibold mb-2 mt-2 cursor-pointer flex-1 select-none"
                                        onClick={() => {
                                            dispatch({
                                                type: 'SET_OPEN_FILTER',
                                                openFilter: !openFilter
                                            })
                                        }}>{t("accreditation.filter")}</span>

                                  <div className={"flex gap-2 ml-auto pb-2"}>
                                      {(shownFilters && shownFilters.length !== 0 && openFilter) && <div
                                          className={" select-nonetext-right  flex flex-row space-x-1 text-grey-800 items-center p-1 border border-grey-800 rounded hover:bg-grey-800 hover:text-white"}
                                          onClick={() => {
                                              if (!filterVisible || filterVisible.length === 0) {
                                                  dispatch({
                                                      type: 'SHOW_ALL_FILTERS',
                                                  })
                                              } else {

                                                  dispatch({
                                                      type: 'HIDE_ALL_FILTERS',
                                                  })
                                              }
                                          }
                                          }
                                          style={{cursor: "pointer"}}>
                                          {(!filterVisible || filterVisible.length === 0) ?
                                              <>
                                                  <FiChevronsDown/><span>{t("basics.expandAll")}</span>
                                              </> :
                                              <>
                                                  <FiChevronsUp/><span>{t("basics.collapseAll")}</span>
                                              </>}
                                      </div>}
                                      <UserFilterSetModal/>
                                      <div
                                          className={"select-none text-right  flex flex-row space-x-1 text-grey-800 items-center p-1 border border-grey-800 rounded hover:bg-grey-800 hover:text-white"}
                                          onClick={() => {
                                              dispatch({
                                                  type: 'SET_OPEN_FILTER',
                                                  openFilter: !openFilter
                                              })
                                          }
                                          }
                                          style={{cursor: "pointer"}}>{openFilter ? <>
                                          <FiChevronUp/><span>{t("basics.collapse")}</span></> : <>
                                          <FiChevronDown/><span>{t("basics.expand")}</span></>}
                                      </div>
                                  </div>
                              </div>
                              {openFilter && <>
                                  <div className="flex flex-col space-y-2">
                                      {renderBasicsFields()}
                                      {renderCustomFields()}
                                      {renderPrintEmail(values, form)}
                                      {renderEntrance(values)}
                                      {renderRegistration(values)}
                                      {renderDays()}
                                      <div className={"flex flex-row space-x-2 justify-end pt-2 w-1/3 ml-auto"}>
                                          {filtered &&
                                              <div className={"w-1/2"}><EnigooButton extraStyle={"btn-block w-1/2"}
                                                                                     color={"red"} onClick={() => {
                                                  dispatch({
                                                      type: 'SET_FILTERED',
                                                      filtered: false,
                                                  })
                                                  let newVal = {};
                                                  newVal.wasSend = undefined;
                                                  newVal.wasPrint = undefined;
                                                  newVal.groups = undefined;
                                                  dispatch({
                                                      type: 'SET_FILTER_DATA',
                                                      filterData: newVal
                                                  })
                                              }}
                                                                                     text={t("basics.showAll")}
                                                                                     loading={filtering}
                                                                                     disabled={filtering}
                                                                                     icon={<FiFilter
                                                                                         className={"mr-3"}/>}/>
                                              </div>}
                                          {(shownFilters && shownFilters.length !== 0) &&
                                              <div className={"w-1/2"}><EnigooButton extraStyle={"btn-block "}
                                                                                     onClick={handleSubmit}
                                                                                     text={t("basics.filter")}
                                                                                     loading={filtering}
                                                                                     disabled={filtering || !dirty}
                                                                                     icon={<FiFilter
                                                                                         className={"mr-3"}/>}/>
                                              </div>}
                                      </div>

                                  </div>
                              </>}
                          </>
                      )
                  }}
            />

        </div>
    }

    return <VerifyRights page={"user"} action={"filterUser"}>
        {_renderBody()}
    </VerifyRights>

}
export default UserFilterForm;
